import { jsx as o } from "react/jsx-runtime";
import { ChevronRightIcon as r, ChevronLeftIcon as a } from "../../icons/componentIcons.mjs";
import "../../forms/Button/Button.mjs";
import { IconButton as t } from "../../forms/Button/IconButton.mjs";
import "../../forms/Button/ButtonGroup.mjs";
import { iconSizes as i } from "../../../theme/foundations/icons.mjs";
const l = () => /* @__PURE__ */ o(
  t,
  {
    as: "div",
    variant: "ghost",
    size: "sm",
    "aria-label": "",
    icon: /* @__PURE__ */ o(r, { fontSize: { base: i.sm, md: i.md }, variant: "light" })
  }
), f = () => /* @__PURE__ */ o(
  t,
  {
    as: "div",
    variant: "ghost",
    size: "sm",
    "aria-label": "",
    icon: /* @__PURE__ */ o(a, { fontSize: { base: i.sm, md: i.md }, variant: "light" })
  }
);
export {
  l as NextLabel,
  f as PreviousLabel
};
